import React from "react";
import { Redirect } from "react-router-dom";

import { ASSET_OVERVIEW_ROUTE } from "components/router/Routes";

const AssetView: React.FC = () => {
    return <Redirect to={ASSET_OVERVIEW_ROUTE.path} />;
};

export default AssetView;
